import { render, staticRenderFns } from "./InformativaSito.vue?vue&type=template&id=b09f46d6&scoped=true&"
import script from "./InformativaSito.vue?vue&type=script&lang=js&"
export * from "./InformativaSito.vue?vue&type=script&lang=js&"
import style0 from "./InformativaSito.vue?vue&type=style&index=0&id=b09f46d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09f46d6",
  null
  
)

export default component.exports